import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import clsx from 'clsx';
import { useDevice } from '@atc/react-device';
import { getImageSizeBasedOnViewport } from '@atc/images';
import { PositionedOverlay } from 'reaxl';
import { InventoryImage } from 'reaxl-molecules';
import InventoryListingImagePreviews from './InventoryListingImagePreviews.js';
function InventoryListingImage(_ref) {
  let {
    className,
    data = {},
    lazyLoad = true,
    listingCTA = {},
    loading,
    orientation,
    uiContext = 'listing',
    withPreviewImages = false,
    // only true for 'simplified' uiContext (highlight)
    ...rest
  } = _ref;
  const device = useDevice();
  const imgSizes = getImageSizeBasedOnViewport({
    device,
    lazyLoad
  });
  const imageSources = _get(data, 'images.sources', []);
  const imageIndex = _get(data, ['images', 'primary'], 0);
  const image = imageSources[imageIndex] || {};
  return /*#__PURE__*/React.createElement("div", Object.assign({
    key: "inventory-listing-images"
  }, withPreviewImages ? {
    className: 'padding-horizontal-3'
  } : {}), /*#__PURE__*/React.createElement(PositionedOverlay, Object.assign({
    "data-cmp": "inventoryListImage",
    shrinkwrap: false,
    className: clsx('inventory-listing-media text-center', className)
  }, rest), /*#__PURE__*/React.createElement(PositionedOverlay.Base, Object.assign({
    className: clsx({
      'image-container': image.src && uiContext === 'listing',
      'bg-gray-darker': image.src
    })
  }, imgSizes), /*#__PURE__*/React.createElement(InventoryImage, Object.assign({
    uiContext: uiContext,
    className: "img-responsive-scale",
    lazyLoad: lazyLoad,
    loading: loading
  }, image, imgSizes)))), withPreviewImages && /*#__PURE__*/_jsx(InventoryListingImagePreviews, {
    images: imageSources
  }));
}
export default InventoryListingImage;